
import { TeacherNotification } from '@/services/db/teachers/notifications/types';
import { NotificationCategory, NotificationPriority } from '@/types/notifications';

export class TeacherNotificationService {
  createTeacherNotification(
    title: string,
    message: string,
    teacherId: string,
    teacherName: string | undefined,
    category: NotificationCategory,
    priority: NotificationPriority
  ): TeacherNotification {
    return {
      id: crypto.randomUUID(),
      teacherId,
      type: this.mapCategoryToType(category),
      title,
      message,
      createdAt: new Date(),
      isRead: false,
      read: false,
      metadata: {
        teacherName,
        priority,
        category
      }
    };
  }

  private mapCategoryToType(category: NotificationCategory): any {
    const typeMap: Record<NotificationCategory, string> = {
      payment: 'payment',
      document: 'document',
      attendance: 'attendance',
      exam: 'qualification',
      program: 'other',
      system: 'info'
    };
    
    return typeMap[category] || 'info';
  }
}
